"use client"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

export function MetaAdsCloseConfirmationDialog({
  open,
  connectionSaved,
  onOpenChange,
  onConfirm,
}: {
  open: boolean
  connectionSaved: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Close Meta Ads setup?</AlertDialogTitle>
          <AlertDialogDescription>
            {connectionSaved
              ? "Your Page is saved, but unfinished setup steps will remain. You can continue later from Integrations."
              : "Your progress in this setup window will be lost. You can start again from Integrations."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep setting up</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Close setup</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
